import { createContext, useContext } from 'react';

import type { CatalogMediaConfig, PublicCatalogService } from '../api/types';

export type CatalogContextValue = { service: PublicCatalogService; media: CatalogMediaConfig };

export const CatalogContext = createContext<CatalogContextValue | undefined>(undefined);

export function useCatalog() {
  const value = useContext(CatalogContext);
  if (!value) throw new Error('useCatalog must be used within CatalogProvider.');
  return value;
}
